/**
 * Met une erreur inconnue sous forme lisible, pour le bloc « Détails
 * techniques » des écrans d'erreur.
 *
 * Ce qui arrive à une barrière d'erreur n'est PAS toujours une `Error` : React
 * Router peut remonter une `Response`, une bibliothèque peut jeter une chaîne
 * ou un objet nu. Les afficher tels quels donnait « [object Object] », la seule
 * chose qu'un développeur ne peut pas exploiter.
 *
 * Dans un fichier à part : un module qui exporte à la fois des composants et
 * des fonctions casse le rafraîchissement à chaud de Vite (react-refresh).
 */
export function describeError(error: unknown): string {
  if (error instanceof Error) return `${error.name}: ${error.message}\n\n${error.stack ?? ""}`;
  if (typeof error === "string") return error;
  try {
    return JSON.stringify(error, null, 2);
  } catch {
    // Références circulaires, getters qui jettent… `String()` s'en sort toujours.
    return String(error);
  }
}
